import { useLocalization } from 'shared-ui/localization'
import { PROPAGATION_PREVIEW_STROKES } from 'shared-ui/map'

const SWATCH_WIDTH = 24
const SWATCH_HEIGHT = 10

enum LegendEntry {
  Infill = 'infill',
  Headlands = 'headlands',
  HeadlandBoundary = 'headlandBoundary'
}

const LEGEND_ROWS = [
  { entry: LegendEntry.Infill, stroke: PROPAGATION_PREVIEW_STROKES.INFILL },
  { entry: LegendEntry.Headlands, stroke: PROPAGATION_PREVIEW_STROKES.HEADLAND },
  { entry: LegendEntry.HeadlandBoundary, stroke: PROPAGATION_PREVIEW_STROKES.HEADLAND_BOUNDARY }
]

const Swatch = ({ color, lineDash }: { color: string; lineDash?: number[] }) => (
  <svg width={SWATCH_WIDTH} height={SWATCH_HEIGHT} className="rounded-sm bg-gray-500" aria-hidden>
    <line
      x1={2}
      y1={SWATCH_HEIGHT / 2}
      x2={SWATCH_WIDTH - 2}
      y2={SWATCH_HEIGHT / 2}
      stroke={color}
      strokeWidth={2}
      strokeDasharray={lineDash?.join(' ')}
    />
  </svg>
)

/**
 * Explains the strokes of the propagated guidance preview on the map.
 */
export const PropagationLegend = () => {
  const { t } = useLocalization()
  const labels: Record<LegendEntry, string> = {
    [LegendEntry.Infill]: t(($) => $.planning.propagationLegend.infill),
    [LegendEntry.Headlands]: t(($) => $.planning.headlands),
    [LegendEntry.HeadlandBoundary]: t(($) => $.planning.propagationLegend.headlandBoundary)
  }
  return (
    <ul className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500">
      {LEGEND_ROWS.map(({ entry, stroke }) => (
        <li key={entry} className="flex items-center gap-1.5">
          <Swatch color={stroke.color} lineDash={stroke.lineDash} />
          {labels[entry]}
        </li>
      ))}
    </ul>
  )
}
